import { Android, Apple } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import PropTypes from "prop-types";

StoreIcon.propTypes = {
	store: PropTypes.number.isRequired,
	sx: PropTypes.object,
};

export default function StoreIcon({ store, sx, ...other }) {
	const theme = useTheme();

	const defaultSx = {
		fontSize: "1rem",
		color: theme.palette.text.secondary,
		...sx,
	};

	if (store === 0) {
		return <Apple sx={defaultSx} {...other} />;
	} else if (store === 1) {
		return <Android sx={defaultSx} {...other} />;
	}

	return null;
}
